export const ROLE_ROUTES = {
  seller: "maltora-seller",
  customer: "maltora-customer",
  salesRep: "maltora-sales-rep",
} as const;

export type MaltoraRole = (typeof ROLE_ROUTES)[keyof typeof ROLE_ROUTES];

const ROLE_MAPPING: Record<string, MaltoraRole> = {
  seller: ROLE_ROUTES.seller,
  customer: ROLE_ROUTES.customer,
  "sales-rep": ROLE_ROUTES.salesRep,
  [ROLE_ROUTES.seller]: ROLE_ROUTES.seller,
  [ROLE_ROUTES.customer]: ROLE_ROUTES.customer,
  [ROLE_ROUTES.salesRep]: ROLE_ROUTES.salesRep,
};

export const normalizeRole = (role?: string | null): string => {
  const normalizedRole = role?.trim().toLowerCase() || "";
  return ROLE_MAPPING[normalizedRole] || normalizedRole;
};

export const normalizeRoles = (roles?: string[] | null): string[] =>
  (roles || []).map(normalizeRole);
